import { apiCall } from '@/lib/api-client';
import type { AuthTokens } from '@/types/api';

export interface LoginInput {
  email: string;
  password: string;
  mfaCode?: string;
}

export const authApi = {
  login: (input: LoginInput) =>
    apiCall<AuthTokens>('/auth/login', {
      method: 'POST',
      body: input,
      skipAuthRefresh: true,
    }),

  logout: () =>
    apiCall<void>('/auth/logout', {
      method: 'POST',
    }),

  me: () => apiCall<{ sub: string; role: string; sid: string }>('/auth/me', { method: 'POST' }),
};
